import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import MindmapV2 from '@/components/mindmapV2';
import Markdown from '@/components/markdown';
import Anchor from '../Anchor';
import { Radio } from 'antd';
const RadioGroup = Radio.Group;
import "./index.scss";
import { useMemo } from 'react';
import { isStringEmpty } from '@shared/utils';
import { SVGPureIcon } from '@/ui';
import chatStoreManager from '@/store/chat/manager';

const MD_URL_RE = /\[(\[[^]]*\]\([^)]*\))\]/gm;

const VideoPoint = observer((props) => {
  const {
    item,
    index,
    isLast,
  } = props;

  const [isFold, setFold] = useState(false);

  return (
    <div className={`video-point ${isLast ? 'video-point-last' : ''} pb-[4px]`}>
      <div className="flex text-primary-opacity text-opacity-90 text-[14px] leading-[26px] font-bold">
        <div className="mr-[8px]">{item.time}</div>
        <div className="w-0 flex-grow mr-[16px]">
          {item.content}
        </div>
        <div 
          className={`size-16px flex items-center justify-center cursor-pointer transition-transform transition-[0.25s] transform ${isFold ? '' : 'rotate-[180deg]'}`}
          onClick={
            () => {
              setFold(_ => !_);
            }
          }
          >
          <SVGPureIcon name="fold" className="w-full h-full opacity-80 text-primary-opacity">
          </SVGPureIcon>
        </div>
      </div>
      <div className={`pl-[26px] pt-[8px] ${isFold ? 'hidden' : ''}`}>
        {
          (item.detail || []).map((detail, index) => {
            return (
              <div 
                className="video-point-detail text-[12px] leading-[22px] text-primary-opacity text-opacity-70 mb-[8px]" 
                key={index}
                >
                {detail}
              </div>
            )
          })
        }
      </div>
    </div>
  )
});

const VideoItem = observer((props) => {
  const {
    index,
    msg_id,
    msg_type,
    loading = false,
    typing = false,
    role_id,
    txt,
    prompt: question,
    page = [],
    search_keyword = [],
    search_total,
    refer_search,
    result: answer = '',
    is_doing,
    compare_parent_id,
    role_biz,
    mind_map,
    is_white,
    status,
    kwargs,
    video_watch,
  } = props;

  const chatStore = chatStoreManager.current;

  const isCompleted = is_doing == 0;
  const text = useMemo(() => {
    if (isStringEmpty(answer)) {
      return answer;
    }

    return answer.replace(MD_URL_RE, (input, replaceValue) => {
      return isStringEmpty(replaceValue) ? input : replaceValue;
    });
  }, [answer]);
  const parseResult = useMemo(() => {
    if(!video_watch?.length){
      return null;
    }
    const parseResult = video_watch[0].parse_result;
    if(parseResult?.length){
      return parseResult;
    }
    return null;
  }, [video_watch]);

  return (
    <div>
      {
        mind_map && status != -1
        ? (
          <div className={`mt-4px w-332px`}>
            <MindmapV2 
              className=""
              mindmap={mind_map} 
              prompt={question}
              chatId={chatStore.chatId}
              msgId={msg_id}
              page={page}
              hideTip={true}
              />
          </div>
        )
        : null
      }
      <div className={``}>
        <div className="mt-24px">
          <Markdown
            typing={typing}
            text={text}
            components={{
              a: props => (
                <Anchor
                  {...props}
                  tooltipable={isCompleted}
                  references={refer_search}
                />
              ),
            }}
            />
        </div>
        {
          parseResult && status != -1
          ? (
            <div className="mt-16px">
              <div className="text-primary-opacity text-opacity-90 font-bold leading-28px text-16px">视频亮点</div>
              <div className="mt-17px">
                {
                  parseResult.map((item, index, arr) => {
                    const isLast = index == arr.length - 1;
                    return <VideoPoint key={index} item={item} isLast={isLast} />
                  })
                }
              </div>
            </div>
          )
          : null
        }
      </div>
    </div>
  )
});
export default VideoItem;